import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import withCollectionStepper from 'Components/ComponentLibrary/HigherOrderComponents/withCollectionStepper';
import fr from 'facet-rest';
import WizardCollectionStepperTemplateContent from './Content';

const styles = () => ({
  root: {},
});

const WizardCollectionStepperTemplate = ({
  className,
  classes,
  layout,
  metaOverrideSet,
  collection,
  template,
}) => {
  const ContentWithCollectionStepper = withCollectionStepper(collection, WizardCollectionStepperTemplateContent);

  return (
    <ContentWithCollectionStepper
      className={classNames(className, classes.root)}
      layout={layout}
      metaOverrideSet={metaOverrideSet}
      template={template}
    />
  );
};

WizardCollectionStepperTemplate.defaultProps = {
  className: '',
  metaOverrideSet: undefined,
};

WizardCollectionStepperTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  layout: PropTypes.object.isRequired,
  metaOverrideSet: PropTypes.object,
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  /** Template is used for Amplitude logging */
  template: PropTypes.string.isRequired,
};

export default withStyles(styles)(WizardCollectionStepperTemplate);
